import type { NextApiRequest, NextApiResponse } from 'next'
import type { UpdateOrderPayload, UpdateOrderResponse } from 'ecosystem'
import { nexiApi } from 'api/utils/nexi'

export const nexiPaymentProvider = async (
  req: NextApiRequest,
  res: NextApiResponse<UpdateOrderResponse | { error: string }>
) => {
  const { nexiPayload }: UpdateOrderPayload = JSON.parse(req.body)

  if (!nexiPayload) {
    res.status(400).json({ error: 'Wrong payload' })
    return
  }

  const { paymentId, ...updatedOrder } = nexiPayload

  const { error } = await nexiApi.checkout.updateOrder(paymentId, {
    ...updatedOrder,
    shipping: {
      costSpecified: true
    }
  })

  if (error) {
    res.status(400).json({ error: error || 'Unknown error' })
    return
  }

  res.status(200).json({ nexiResponse: true } as UpdateOrderResponse)
}
